export default {
	name: 'redirect',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
		};
	},
	computed: {
	},
	watch: {},
	created() {
    },
	mounted() {
        this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		init() {
            let historyPage = sessionStorage.getItem('historyPage');

			if (!historyPage || historyPage == '/' || historyPage == '' || historyPage.endsWith('/redirect')) {
				this.$router.push('functionList');
			} else {
				window.location.href = historyPage;
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/redirect/redirect.js